import { render } from "./About.vue?vue&type=template&id=74eab083&scoped=true"
import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=74eab083&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74eab083"],['__file',"resources/js/frontend/components/About.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74eab083"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74eab083', __exports__)) {
    console.log('reload')
    api.reload('74eab083', __exports__)
  }
  
  module.hot.accept("./About.vue?vue&type=template&id=74eab083&scoped=true", () => {
    console.log('re-render')
    api.rerender('74eab083', render)
  })

}


export default __exports__